/**
 * 受注（回収・積替・搬入）
 * キャンセル登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/directly_cancels`

const orders_accepts_directly_cancel = {
  namespaced: true,
  actions: {
    delete ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.delete(api_path).then( data => {
          commit('snackbar/showInfo', { message: 'キャンセルしました' }, { root: true })
          resolve(data.result)
        } )
      })
    },
  },
}
export default orders_accepts_directly_cancel
